import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldTableDto} from "@tj/tj-dmp-lib-api";

@Component({
    selector: 'dmp-data-field',
    templateUrl: './data-field.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DataFieldComponent implements OnInit {
    isWrite = false;
    field: FieldTableDto = null;
    value: any = null;
    @Input() fields: FieldTableDto[];
    @Input() dbTable: string;
    @Input() dbField: string;
    @Input() rawValue: any;
    @Output() valueChange = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
      this.value = this.rawValue['id'];
      this.field = this.fields.find(f => f.table === this.dbTable && f.code === this.dbField);
  }

}
